import React, { useState } from "react";
import { Typography, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DescriptionIcon from "@mui/icons-material/Description";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { downloadTemplate, openUserGuide } from "../../utils/downloadTemplate";

const UserGuideMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadTemplate = () => {
    downloadTemplate();
    handleClose();
  };

  const handleOpenUserGuide = () => {
    openUserGuide();
    handleClose();
  };

  return (
    <>
      <Typography
        role="button"
        onMouseEnter={handleMouseEnter}
        sx={{
          color: "#bb1ccc",
          fontSize: "14px",
          fontWeight: "400",
          textDecoration: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          "&:hover": { textDecoration: "underline" },
          
        }}
      >
        <MenuBookIcon sx={{ fontSize: "20px", color: "#bb1ccc" }} />
        <span>User Guide</span>
      </Typography>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          onMouseLeave: handleClose,
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "8px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            minWidth: "280px",
            mt: 1,
          },
        }}
      >
        <MenuItem
          onClick={handleDownloadTemplate}
          sx={{
            py: 1.5,
            "&:hover": {
              backgroundColor: "#f0f0ff",
            },
          }}
        >
          <ListItemIcon>
            <DescriptionIcon sx={{ color: "#bb1ccc" }} />
          </ListItemIcon>
          <ListItemText
            primary="Download Excel for Rule Configuration"
            primaryTypographyProps={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#333",
            }}
          />
        </MenuItem>
        <MenuItem
          onClick={handleOpenUserGuide}
          sx={{
            py: 1.5,
            "&:hover": {
              backgroundColor: "#f0f0ff",
            },
          }}
        >
          <ListItemIcon>
            <OpenInNewIcon sx={{ color: "#bb1ccc" }} />
          </ListItemIcon>
          <ListItemText
            primary="View Documentation"
            primaryTypographyProps={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#333",
            }}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserGuideMenu;

